module.exports = __webpack_public_path__ + "img/concern.0a55040.png";